import React from "react";
import { ProjectPlanPageInitialState, PageNewState } from ".";

export const ProjectPlanPageContext = React.createContext({
  pageState: ProjectPlanPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
